import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

function ExtraMileage({
    isOpen,
    onClose,
    onConfirm,
    appointmentId,
    item,
    loader,
}) {

    const methods = useForm();
    const { control, formState: { errors }, handleSubmit, setValue } = methods;

    useEffect(() => {

        methods.reset({ extra_mileage: '' })

    }, [isOpen])

    useEffect(() => {
        setValue('extra_mileage', item?.appointment_details?.extra_mileage || '')
        setValue('vendor_id', item?.vendor_id || '')
    }, [item, isOpen])


    return (
        <>
            <Modal isOpen={isOpen} toggle={onClose} centered className="modal-medium">
                <form action="" onSubmit={handleSubmit((data) => onConfirm(data, "extra_mileage"))}>
                    <ModalHeader className='header_modal align-items-center'>
                        <h5 className="modal-title_u">Request Extra Mileage</h5>
                    </ModalHeader>
                    <ModalBody className='modal_form_body'>
                        <div className='step_cards step_1 min-height-auto'>
                            <h2>Job ID: {appointmentId}</h2>
                            <div className="row-primary">
                                <h2>Extra Mileage Pay</h2>
                                <div className='w-100'>

                                    <div className="row-primary w-100">
                                        <Controller
                                            name="extra_mileage"
                                            control={control}
                                            rules={{
                                                required: "Please write pay amount"
                                            }}
                                            render={({ field }) =>
                                                <div className='w-100'>
                                                    <input
                                                        type='number'
                                                        className="type_inp input-in"
                                                        {...field}
                                                        placeholder='Write pay amount...'
                                                    />

                                                    {errors?.extra_mileage?.message && (
                                                        <ErrorMessage
                                                            text={errors?.extra_mileage?.message}
                                                        />
                                                    )}
                                                </div>
                                            }

                                        />
                                    </div>
                                    <Controller
                                        name="vendor_id"
                                        control={control}
                                        render={({ field }) =>
                                            <input type='hidden'{...field} />
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <SubmitButton buttonType="submit" loader={loader} btnText="Request" />
                        <button className="table_delete" type='button' onClick={onClose}>Cancel</button>
                    </ModalFooter>
                </form>
            </Modal>
        </>
    );
}

export default ExtraMileage;